import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PageFor } from "../../../../../../utils/Enum.types";
import QuotationForm from "./QuotationForm";
import QuotationLogin from "./QuotationLogin";
import Preview from "./Preview";
import SupplierTerms from "./SupplierTerms";
import Success from "./Success";
import ReviewQuotation from "./ReviewQuotation";
import FillItemQuotation from "./FillItemQuotation";

const QuotationRoutes = () => {
  return (
    <div className="h100">
      <Router>
        <Routes>
          <Route path="/vendor/quotationlogin" element={<QuotationLogin />} />
          <Route path="/vendor/:uuid/quotationpreview" element={<Preview />} />
          <Route
            path="/vendor/:uuid/quotationform/details"
            element={<QuotationForm step={1} />}
          />
          <Route
            path="/vendor/:uuid/quotationform/supplierterms"
            element={<SupplierTerms step={2} pageType={PageFor.GENERAL} />}
          />

          <Route
            path="/vendor/:uuid/quotationform/success"
            element={<Success />}
          />
          <Route
            path="/vendor/:uuid/quotationform/reviewandsubmit"
            element={<ReviewQuotation />}
          />
          <Route
            path="/vendor/:uuid/quotationform/details/:rfqTrnSupplyId/fill_item"
            element={<FillItemQuotation />}
          />
        </Routes>
      </Router>
    </div>
  );
};

export default QuotationRoutes;
